import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangePassword } from '../model/profile';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient,
    private cookieService: CookieService
  ) { }
  private profile$?: Observable<any>;
  private readonly baseUri = 'profile'
  private cachedToken?: string;

  getProfile() {
    return this.http.get('profile');
  }

  updateProfile(data) {
    return this.http.patch('profile', data);
  }

  archiveProfile(data) {
    return this.http.patch('profile/archive', data);
  }
  public changePassword(changePasswordPayload: ChangePassword) {
    return this.http.patch(`${this.baseUri}/change-password`, changePasswordPayload);
  }

  getProfilePermission(): Observable<any> {
    if (!this.profile$) {
      this.profile$ = this.http.get('/api/profile').pipe(
        shareReplay(1)
      );
    }
    return this.profile$;
  }

  invalidateCache() {
    this.profile$ = undefined;
    this.cachedToken = undefined;
  }

  getProfileCached(forceRefresh = false): Observable<any> {
    const token = this.cookieService.get('token') || '';

    if (this.cachedToken !== token) {
      this.profile$ = undefined;
      this.cachedToken = token;
    }

    if (forceRefresh) this.profile$ = undefined;

    if (!this.profile$) {
      this.profile$ = this.http.get(this.baseUri).pipe(
        catchError((err) => {
          this.profile$ = undefined;
          return throwError(() => err);
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }

    return this.profile$;
  }

}

